<template>
  <NuxtLink
    :to="'/' + slug"
    class="focus:outline-none flex items-center justify-center flex-col"
    :title="name"
  >
    <component :is="findIcon(slug)" stroke-width="1.5" class="mb-2" />
    <span>{{ name }}</span>
  </NuxtLink>
</template>
<script>
import {
  ArrowRightIcon,
  BrandYoutubeIcon,
  Stack3Icon,
  TextSizeIcon,
  LinkIcon,
  FileTextIcon,
  LayoutCollageIcon,
  VinylIcon,
  AddressBookIcon,
  Map2Icon,
  CalendarIcon,
  WifiIcon,
  MailIcon,
  MessageIcon,
  IdIcon,
} from "vue-tabler-icons";
export default defineComponent({
  components: {
    ArrowRightIcon,
    BrandYoutubeIcon,
    Stack3Icon,
    TextSizeIcon,
    LinkIcon,
    FileTextIcon,
    LayoutCollageIcon,
    VinylIcon,
    AddressBookIcon,
    Map2Icon,
    CalendarIcon,
    WifiIcon,
    MailIcon,
    MessageIcon,
    IdIcon,
  },
  props: {
    name: {
      type: String,
    },
    icon: {
      type: String,
    },
    slug: {
      type: String,
    },
  },
  methods:{
    findIcon(slug){
      switch(slug){
        case "text":
          return 'TextSizeIcon'
        case "url":
          return 'LinkIcon'
        case "document":
          return 'FileTextIcon'
        case "image":
          return 'LayoutCollageIcon'
        case "multimedia":
          return 'VinylIcon'
        case "vcard":
          return 'IdIcon'
        case "map":
          return 'Map2Icon'
        case "event":
          return 'CalendarIcon'
        case "wifi":
          return 'WifiIcon'
        case "email":
          return 'MailIcon'
        case "sms":
          return 'MessageIcon'
        default:
        return 'Stack3Icon'
      }
    }
  }
});
</script>
